/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProjectDataService } from '../../../../../utils/src/lib/sysque-backend/project-data-service';
import { concatMap, map } from 'rxjs/operators';

import {
  GetParamCategorySuccess,
  GetParamCategory,
  InitializeAddProjectParameters,
  InitializeAddProjectParametersSuccess,
  GetBuiltInGroupParameters,
  GetBuiltInGroupParametersSuccess,
  GetDefinitionGroupParameters,
  GetDefinitionGroupParametersSuccess,
} from './project-data-action';
import { ParamCategory } from '../../models/add-project-parameter-category';
import { ProjectParameterDataItems } from '@hcworkspace/sysque/toolbelt/feature';
import { ProjectDataParamInfo } from '../../models/add-project-data-params-info';

@Injectable()
export class ProjectDataEffects {
  constructor(private readonly actions$: Actions, private projectService: ProjectDataService) {}

  getParamCategory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetParamCategory),
      concatMap((action) =>
        this.projectService
          .getParamCategory(action.currentCategory)
          .pipe(map((data: ParamCategory[]) => GetParamCategorySuccess({ paramCategory: data })))
      )
    );
  });

  initializeAddProjectParameters$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InitializeAddProjectParameters),
      concatMap(() =>
        this.projectService
          .initializeAddProjectParametersFromJson()
          .pipe(
            map((data: ProjectParameterDataItems[]) =>
              InitializeAddProjectParametersSuccess({ initialProjectParameterDataItems: data })
            )
          )
      )
    );
  });

  getBuiltInGroupParameters$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetBuiltInGroupParameters),
      concatMap(() =>
        this.projectService
          .getBuiltInGroupParameters()
          .pipe(map((data: ProjectDataParamInfo[]) => GetBuiltInGroupParametersSuccess({ projectDataParamInfo: data })))
      )
    );
  });

  getDefinitionGroupParameters$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetDefinitionGroupParameters),
      concatMap(() =>
        this.projectService
          .getDefinitionGroupParameters()
          .pipe(
            map((data: ProjectDataParamInfo[]) => GetDefinitionGroupParametersSuccess({ projectDataParamInfo: data }))
          )
      )
    );
  });
}
